import React, { useState, useEffect } from 'react';
import Loader from './Loader';

const LoaderWithSequentialSteps = () => {
  const [currentStep, setCurrentStep] = useState(0);
  
  const steps = [
    "Drafting the job description",
    "Refining content",
    "Optimizing for maximum impact",
    "Finalizing"
  ];
  
  useEffect(() => {
    const interval = setInterval(() => {
      if (currentStep < steps.length - 1) {
        setCurrentStep(currentStep + 1);
      }
    }, 2000);
    
    return () => clearInterval(interval);
  }, [currentStep]);

  return (
    <div className="fixed inset-0 flex flex-col justify-center items-center">
      <div className="flex flex-col items-center">
        {/* Loader */}
        <div className="flex justify-center items-center w-full">
          <Loader />
        </div>
        
        <div className="h-8 mt-4 text-center w-full">
          <div className="text-md dark:text-gray-300 text-textSecondary">
            {steps[currentStep]}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoaderWithSequentialSteps;